import React, { useEffect, useState, useRef } from 'react';
// import React, { Component, useState } from 'react';
import Player from 'aliplayer-react';
import Share from "./services/Share";
import className from "classnames";
import {
    LaunchApp, copy, detector, ua,
    isAndroid, isIos, supportLink, inWeixin, inWeibo
} from 'web-launch-app';
import './App.css';
function App() {
    return (
        <div className="box">
        </div>
    );
}

export default App;
